<template>
  <a :is="tag" :href="href" class="c-see-more-text-link" v-touch:tap>
    <div class="c-see-more-text-link__text">
      <slot>もっと見る</slot>
    </div>
    <i class="c-see-more-text-link__arrow">
      <IconBase view-box="0 0 5 9" width="5" height="9">
        <path
          d="M0 7.80966L0.758355 8.54584L5 4.42819L0.758355 0.310547L0 1.04673L3.48329 4.42819L0 7.80966Z"
          fill="#B6B6B6"
        />
      </IconBase>
    </i>
  </a>
</template>

<script>
import IconBase from "@/common/components/atoms/IconBase.vue";

export default {
  components: {
    IconBase
  },

  props: {
    tag: {
      type: String,
      default: "a"
    },

    href: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.c-see-more-text-link {
  display: flex;
  align-items: center;

  &__text {
    color: $customize-gray;
    font-size: $text-size__body--s;
    font-weight: bold;
    display: block;
    line-height: 1.6;
  }

  &__arrow {
    display: block;
    margin-left: rem(4);

    svg {
      display: block;
    }
  }
}
</style>
